import React from 'react';
export function Footer() {
  return <footer className="bg-emerald-950 text-ivory/50 py-12 text-center font-sans text-sm font-light border-t border-gold/10" data-id="element-27">
      <div className="max-w-4xl mx-auto px-6" data-id="element-28">
        <div className="mb-6" data-id="element-29">
          <span className="font-serif text-xl text-gold/80 italic" data-id="element-30">
            The Italy Insider Protocol
          </span>
        </div>
        <p className="mb-4" data-id="element-31">
          © {new Date().getFullYear()} Heritage Intelligence. All rights
          reserved.
        </p>
        <div className="flex justify-center gap-6 text-xs" data-id="element-32">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-33">
            Terms of Service
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-34">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-35">
            Contact Support
          </a>
        </div>
      </div>
    </footer>;
}